module.exports = __webpack_public_path__ + "static/img/newbook2.3d2db6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/read/newbook2.png
// module id = Q8fN
// module chunks = 0